import { Box, Grid, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import DataClient from '../../../../../../Service/general_data_service';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
function ProgramDetails(props) {
    const [pageData, setPageData] = useState([])

    useEffect(() => {
        getData()
    }, [])

    const getData = (params) => {
        DataClient.getData('assignment_details/fetch_programme_details?assignment_id=' + props.location.state.currentAssignment.id)
            .then((res) => {
                pageData.length = 0;
                setPageData(pageData.concat(res.programme_details))
            })
            .catch((res) => {

            })
    }


    return <Box my={3}>
        <Grid container direction="row" justify="center" alignItems="center">
            <Grid item xs={12}>
                {
                    pageData.length > 0 && pageData.map((option) => {
                        return <Box mt={3}>
                            <Grid container direction="row" justify="center" alignItems="flex-start">
                                <Grid item xs={3}>
                                    <Typography variant="h2">
                                        <Box textAlign="left" fontWeight="fontWeightBold">{option.label}</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Grid container direction="row" justify="flex-start" alignItems="flex-start">
                                        {
                                            option.values.map((optionValues) => {
                                                return <Grid item xs={6}>
                                                    <FiberManualRecordIcon style={{ fontSize: 8, color: "#707070" }} /> &nbsp;
                                                    <Typography variant="h2" component="span">
                                                        <Box textAlign="left" component="span">{optionValues}</Box>
                                                    </Typography>
                                                </Grid>
                                            })
                                        }
                                    </Grid>

                                </Grid>
                                    <Grid item xs={2}> </Grid>
                            </Grid>
                        </Box>
                    })
                }
            </Grid>
        </Grid>

    </Box >
}

export default ProgramDetails
